"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "h-layout" };
var _hoisted_2 = { class: "h-layout-header" };
var _hoisted_3 = { class: "h-layout-header-right" };
var _hoisted_4 = { class: "tenant" };
var _hoisted_5 = { class: "user" };
var _hoisted_6 = { class: "flex align-items-center cursor-pointer color-primary" };
var _hoisted_7 = { class: "m-r-6" };
var _hoisted_8 = { class: "h-layout-container" };
var _hoisted_9 = { class: "h-layout-container-menu" };
var _hoisted_10 = { class: "h-layout-container-menu_list" };
var _hoisted_11 = ["onClick"];
var _hoisted_12 = { class: "icon" };
var _hoisted_13 = { class: "text" };
var _hoisted_14 = {
    key: 0,
    class: "h-layout-container-submenu"
};
var _hoisted_15 = {
    key: 1,
    class: "h-layout-container-router_view"
};
var element_plus_1 = require("element-plus");
var vue_3 = require("vue");
// import {getrenwumingxilist} from "@/api/doctor";
var vue_router_1 = require("vue-router");
var menu_1 = require("@hview/hview-utils/lib/cache/menu");
var micro_app_1 = require("@micro-zoe/micro-app");
var h_menu_1 = require("./h-menu");
var micro_1 = require("@hview/hview-utils/lib/cache/micro");
var user_1 = require("@hview/hview-utils/lib/cache/user");
var api_1 = require("./api");
var micro_utils_1 = require("@hview/hview-utils/lib/tools/micro-utils");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    setup: function (__props) {
        var router = (0, vue_router_1.useRouter)();
        var route = (0, vue_router_1.useRoute)();
        var isRouterAlive = (0, vue_3.ref)(true);
        // 菜单列表
        var menuList = (0, vue_3.ref)([]);
        menuList.value = menu_1.default.getMenu() || [];
        // 从缓存中获取菜单
        var slotDefault = !!(0, vue_3.useSlots)().default;
        var userInfo = user_1.default.getUserInfo();
        var teamid = user_1.default.getTeam();
        // console.log('teamid-----------------------------************************************',teamid)
        // console.log('userInfo-----------------------------************************************',userInfo)
        var getliaotianroles = function (data) {
            (0, api_1.getliaotianrole)({ teamid: teamid, type: 'chat' }).then(function (res) {
                if (res.data == 1) {
                    menuList.value.push({ id: 7, text: "AI聊天记录", icon: "icon-biaodan", path: "/ai", app: "doctor" });
                    menuList.value.push({ id: 8, text: "会话记录", icon: "icon-biaodan", path: "/chatDoctor", app: "doctor" });
                }
            });
            (0, api_1.getliaotianrole)({ teamid: teamid, type: 'patient' }).then(function (res) {
                if (res.data == 2) {
                    menuList.value.push({ id: 9, text: "患者审核", icon: "icon-biaodan", path: "/jsonform", app: "doctor" });
                }
            });
        };
        getliaotianroles();
        // menuList.value.forEach((item,index)=>{
        //   if(userInfo.is_service == 0 && item.text=="消息"){
        //     menuList.value.splice(index, 1);
        //   }
        // })
        // menuList.value.forEach((item,index)=>{
        //   if(userInfo.role != 'admin' && item.text=="表单" ){
        //     menuList.value.splice(index, 1);
        //   }
        // })
        // menuList.value.forEach((item,index)=>{
        //   if(userInfo.role != 'admin' && item.text=="文章" ){
        //     menuList.value.splice(index, 1);
        //   }
        // })
        if (teamid == 44 || teamid == 47 || teamid == 56) {
            menuList.value.push({ id: 9, text: "战队用户数据明细", icon: "icon-biaodan", path: "/shujumingxi", app: "doctor" });
            menuList.value.push({ id: 10, text: "入组行为明细", icon: "icon-biaodan", path: "/ruzuxingwei", app: "doctor" });
            menuList.value.push({ id: 11, text: "任务完成明细", icon: "icon-biaodan", path: "/renwumingxi", app: "doctor" });
        }
        // 
        // 
        // 
        var tenants = user_1.default.getTenant();
        var defaultTenants = (0, vue_3.ref)([]);
        defaultTenants.value = user_1.default.getDefaultTenant();
        var logout = function () {
            element_plus_1.ElMessageBox.confirm('确定退出当前系统吗?', '提示', {
                type: 'warning'
            }).then(function () {
                // userLogoutApi().then(() => {
                user_1.default.clearAll();
                micro_utils_1.default.toLogin();
                // });
            });
        };
        var model = (0, vue_3.ref)({
            tenant: ""
        });
        /**
         * 当前选中的菜单
         */
        var currentMenu = (0, vue_3.ref)(null);
        /**
         * 选中的路径
         */
        var selectPath = (0, vue_3.ref)("");
        /**
         * 激活的app
         * @private
         */
        var activeAppId = (0, vue_3.ref)(-1);
        /**
         * @description 用户触发下拉
         */
        var userCommandEvent = function (data) {
            // console.info(data);
        };
        /**
         * @description 切换租户与社区
         */
        var changeTenants = function (data) {
            user_1.default.setDefaultTenant(data);
            element_plus_1.ElMessage.success("切换成功");
            location.reload();
            isRouterAlive.value = false;
            setTimeout(function () {
                isRouterAlive.value = true;
            }, 300);
        };
        /**
         * @description 切换租户
         */
        var commandEvent = function (data) {
            if (data.tenant_id == defaultTenants.value.tenant_id) {
                element_plus_1.ElMessage.warning("\u5F53\u524D\u5DF2\u7ECF\u662F\u3010".concat(data.name, "\u3011"));
                return;
            }
            element_plus_1.ElMessageBox.confirm("\u786E\u8BA4\u5207\u6362\u5230\u3010".concat(data.name, "\u3011\u5417?"), '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '暂不切换',
                type: 'warning',
            }).then(function (res) {
                if (res == "confirm") {
                    user_1.default.setDefaultTenant(data);
                    defaultTenants.value = data;
                    if (route.path == "/") {
                        // location.reload();
                        isRouterAlive.value = false;
                        setTimeout(function () {
                            isRouterAlive.value = true;
                        }, 300);
                    }
                    else {
                        router.push("/");
                    }
                }
            });
        };
        /**
         * @description 获取需要打开的菜单
         */
        var getMenu = function (menu) {
            // 有子菜单，则直接找子菜单
            if (menu.children && menu.children.length > 0) {
                var menuItem = menu.children[0];
                return getMenu(menuItem);
            }
            else {
                return menu;
            }
        };
        var menuEvent = function (data) {
            var menu = getMenu(data);
            // 如果配置了app，代表是加载子系统，否则直接是打开基座系统的页面
            if (menu.app) {
                var microApp_1 = micro_1.default.getMicroApp() || [];
                // 获取微应用
                var micro = microApp_1.find((function (item) { return item.name == menu.app; }));
                if (micro) {
                    window.history.pushState(null, '', "".concat(micro.baseRoute || micro.path).concat(menu.path));
                    // 主动触发一次popstate事件
                    window.dispatchEvent(new PopStateEvent('popstate', { state: null }));
                    activeAppId.value = data.id;
                    currentMenu.value = data;
                }
                else {
                    throw new Error("\u672A\u627E\u5230\u5FAE\u5E94\u7528\u914D\u7F6E, appName:\u3010".concat(data.app, "\u3011"));
                }
            }
            else { // 基座系统内跳转
                activeAppId.value = 1;
                router.push(data.path);
            }
        };
        /**
         * @description 微应用全局数据监听
         * @param data
         * @private
         */
        var globalDataListener = function (data) {
            // 路由改变触发
            if (data.type == micro_1.MicroMessageType.ROUTE) {
                microRouteEvent(data.data);
            }
        };
        /**
         * @description 选中父菜单
         * @param data
         * @private
         */
        var selectParentMenu = function (matched) {
            var appName = (route || matched).name || "";
            if (!appName) {
                return false;
            }
            var path = matched.path;
            // 如果子页面指定了选中父菜单，则用指定的菜单进行选中
            if (matched.meta && matched.meta.activeMenu) {
                path = matched.meta.activeMenu;
            }
            if (menuList) {
                var menus = menuList.value.filter(function (item) { return item.app == appName; });
                var menuApp = getAppMenuByPath(menus, path);
                if (menuApp) {
                    currentMenu.value = menuApp;
                    activeAppId.value = menuApp.id;
                }
            }
        };
        /**
         * @description 通过path获取菜单
         * @param menuList
         * @param path
         * @private
         */
        var getAppMenuByPath = function (menuList, path) {
            for (var i = 0; i < menuList.length; i++) {
                var item = menuList[i];
                if (item.path == path) {
                    return item;
                }
                else if (item.children && item.children.length > 0) {
                    var result = getAppMenuByPath(item.children, path);
                    if (result) {
                        return item;
                    }
                }
            }
        };
        /**
         * @description 子应用路由变化触发
         * @param data
         * @private
         */
        var microRouteEvent = function (data) {
            // 获取子应用to对象与当前子应用下所有路由表
            var to = data.to, routes = data.routes;
            if (to && to.meta && to.meta.title) {
                document.title = to.meta.title;
            }
            // 获取matched第一条数据
            var matched = to.matched[0];
            if (!matched) {
                return null;
            }
            // 选中父菜单
            selectParentMenu(matched);
            // 获取当前根path
            var path = matched.path;
            // 获取路由项
            var routeItem = routes.find(function (item) { return item.path == path; });
            var children = routeItem.children || [];
            var selectPathStr = path;
            for (var i = 0; i < children.length; i++) {
                var item = children[i];
                if (item.meta && item.meta.primary) {
                    selectPathStr += item.path;
                }
            }
            // 处理选择的path
            selectPathStr = selectPathStr.replace(new RegExp("/$"), "");
            selectPath.value = selectPathStr;
        };
        /**
         * @description 初始化
         * @private
         */
        var init = function () {
            // 没有name的代表是当前项目
            if (route && !route.name && menuList) {
                var path_1 = route.path;
                // 获取portal中的路由
                var portalRoute = menuList.value.filter(function (item) { return item.app == ""; }) || [];
                var menu = portalRoute.find(function (item) { return item.path == path_1; }) || null;
                if (menu) {
                    currentMenu.value = menu;
                    activeAppId.value = menu.id;
                }
            }
        };
        /**
         * @description mounted
         */
        (0, vue_3.onMounted)(function () {
            init();
            micro_app_1.default.addGlobalDataListener(globalDataListener);
        });
        /**
         * @description onUnmounted
         */
        (0, vue_3.onUnmounted)(function () {
            micro_app_1.default.removeGlobalDataListener(globalDataListener);
        });
        return function (_ctx, _cache) {
            var _component_el_cascader = (0, vue_2.resolveComponent)("el-cascader");
            var _component_el_dropdown_item = (0, vue_2.resolveComponent)("el-dropdown-item");
            var _component_el_dropdown_menu = (0, vue_2.resolveComponent)("el-dropdown-menu");
            var _component_el_dropdown = (0, vue_2.resolveComponent)("el-dropdown");
            var _component_el_scrollbar = (0, vue_2.resolveComponent)("el-scrollbar");
            var _component_router_view = (0, vue_2.resolveComponent)("router-view");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    _cache[4] || (_cache[4] = (0, vue_2.createElementVNode)("div", { class: "h-layout-header-logo" }, [
                        (0, vue_2.createElementVNode)("img", {
                            class: "w-50 m-r-10",
                            src: "https://aixin-download.oss-cn-beijing.aliyuncs.com/qianliu-admin/qianliu/logo-2.png"
                        })
                    ], -1)),
                    _cache[5] || (_cache[5] = (0, vue_2.createElementVNode)("div", { class: "font-size-24" }, " 千流健康管理 ", -1)),
                    _cache[6] || (_cache[6] = (0, vue_2.createElementVNode)("div", null, null, -1)),
                    _cache[7] || (_cache[7] = (0, vue_2.createElementVNode)("div", { class: "h-layout-header-center" }, null, -1)),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("div", { class: "message" }, null, -1)),
                        (0, vue_2.createElementVNode)("div", _hoisted_4, [
                            (0, vue_2.createVNode)(_component_el_cascader, {
                                placeholder: "请选择租户和社区",
                                modelValue: defaultTenants.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((defaultTenants).value = $event); }),
                                onChange: changeTenants,
                                style: { "width": "300px" },
                                options: (0, vue_2.unref)(tenants)
                            }, null, 8, ["modelValue", "options"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createVNode)(_component_el_dropdown, { onCommand: userCommandEvent }, {
                                dropdown: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createVNode)(_component_el_dropdown_menu, null, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (0, vue_2.createVNode)(_component_el_dropdown_item, {
                                                onClick: logout,
                                                command: "logout",
                                                divided: ""
                                            }, {
                                                default: (0, vue_2.withCtx)(function () { return _cache[2] || (_cache[2] = [
                                                    (0, vue_2.createElementVNode)("i", { class: "el-icon-switch-button" }, null, -1),
                                                    (0, vue_2.createTextVNode)("退出系统")
                                                ]); }),
                                                _: 1
                                            })
                                        ]; }),
                                        _: 1
                                    })
                                ]; }),
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                        (0, vue_2.createElementVNode)("span", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(userInfo).realname || (0, vue_2.unref)(userInfo).nickname), 1),
                                        _cache[1] || (_cache[1] = (0, vue_2.createElementVNode)("span", { class: "iconfont icon-yonghu" }, null, -1))
                                    ])
                                ]; }),
                                _: 1
                            })
                        ])
                    ])
                ]),
                (0, vue_2.createElementVNode)("div", _hoisted_8, [
                    (0, vue_2.createElementVNode)("div", _hoisted_9, [
                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                            (0, vue_2.createVNode)(_component_el_scrollbar, { class: "h-layout-container-menu_list__scrollbar" }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (0, vue_2.createElementVNode)("div", null, [
                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(menuList), function (item, index) {
                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                class: (0, vue_2.normalizeClass)(["menu-item", { active: item.id == (0, vue_2.unref)(activeAppId) }]),
                                                onClick: function ($event) { return (menuEvent(item)); },
                                                key: index
                                            }, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                                    (0, vue_2.createElementVNode)("span", {
                                                        class: (0, vue_2.normalizeClass)(["iconfont", item.icon])
                                                    }, null, 2)
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_13, (0, vue_2.toDisplayString)(item.text), 1)
                                            ], 10, _hoisted_11));
                                        }), 128))
                                    ])
                                ]; }),
                                _: 1
                            })
                        ])
                    ]),
                    ((0, vue_2.unref)(currentMenu) && (0, vue_2.unref)(currentMenu).children && (0, vue_2.unref)(currentMenu).children.length > 0)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_14, [
                            (0, vue_2.createVNode)((0, vue_2.unref)(h_menu_1.default), {
                                menuList: (0, vue_2.unref)(currentMenu).children,
                                active: (0, vue_2.unref)(selectPath)
                            }, null, 8, ["menuList", "active"])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (isRouterAlive.value)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, [
                            slotDefault
                                ? (0, vue_2.renderSlot)(_ctx.$slots, "default", { key: 0 })
                                : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_view, { key: 1 }))
                        ]))
                        : (0, vue_2.createCommentVNode)("", true)
                ])
            ]));
        };
    }
});
